import PathReportingMappingDto from "../../../dtos/pathreportingmodule/PathReportingMappingDto";
import ScheduleDto from "../../../dtos/schedulermodule/ScheduleDto";
import DataTableReadDto from "../../../dtos/pathcommonmodule/DataTableReadDto";

class GetPathReportingDetailResult {
    Id: number;
    Name: string;
    Source: DataTableReadDto | null;
    Mappings: PathReportingMappingDto[];
    Schedule: ScheduleDto;
    AdvancedFilterMode: boolean;
    LastVersionId: number | null;
    PublishedVersionId: number | null;

    constructor(id: number, name: string, source: DataTableReadDto | null, mappings: PathReportingMappingDto[], schedule: ScheduleDto, lastVersionId: number | null, publishedVersionId: number | null, advancedFilterMode: boolean) {
        this.Id = id;
        this.Name = name;
        this.Source = source;
        this.Mappings = mappings;
        this.Schedule = schedule;
        this.LastVersionId = lastVersionId;
        this.PublishedVersionId = publishedVersionId;
        this.AdvancedFilterMode = advancedFilterMode;
    }
}

export default GetPathReportingDetailResult;
